import { CATEGORY_GRID_STYLES, MEDICAL_CATEGORY_CONFIG } from '../lib/constants';
import CategoryItemSkeleton from './CategoryItemSkeleton';

interface CategoryGridProps {
  children: React.ReactNode;
  isLoading: boolean;
}

const CategoryGrid = ({ children, isLoading }: CategoryGridProps) => {
  if (isLoading) {
    return (
      <div className={CATEGORY_GRID_STYLES.CONTAINER}>
        <div className={CATEGORY_GRID_STYLES.GRID}>
          {Array.from({ length: MEDICAL_CATEGORY_CONFIG.SKELETON_COUNT }).map((_, index) => (
            <CategoryItemSkeleton key={index} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={CATEGORY_GRID_STYLES.CONTAINER}>
      <div className={CATEGORY_GRID_STYLES.GRID}>{children}</div>
    </div>
  );
};

export default CategoryGrid;
